
<div [formGroup]="form">
  <input [formControlName]="question.key" [id]="question.key" type="hidden">
  <div class="raptor-increment-group" [class]="{'open-increment-disabled': question.settings.disabled }">
    <div class="raptor-increment-button-container">
      <button class="raptor-increment-remove" type="button" mat-icon-button color="primary" (click)="reduce()" [disabled]="rawValue <= min || question.settings.disabled === true">
        <mat-icon>remove</mat-icon>
      </button>
    </div>

    <span>{{ fieldValue }}</span>

    <div class="raptor-increment-button-container">
      <button class="raptor-increment-add" type="button" mat-icon-button color="primary" (click)="increase()" [disabled]="rawValue >= max || question.settings.disabled === true">
        <mat-icon>add</mat-icon>
      </button>
    </div>
  </div>
</div>